<div class="viewport viewport-full viewport-center bg-secondary">
  <div class="content">
    <h1>{{ 'RESPONSE.FAILURE.title' | translate }}</h1>
    <h2>{{ 'RESPONSE.FAILURE.description' | translate }}</h2>
    <button kendoButton themeColor="light" size="large" (click)="restart()">{{ 'RESPONSE.FAILURE.startAgain' | translate }}
    </button>
  </div>
  <div class="logo-wrapper">
    <img ngSrc="/images/logo_w_text_white.png" alt="Famulus Logo with text" priority fill>
  </div>
</div>
